import React, {useState, useEffect, useRef} from 'react';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';

function Wizard(props){
  const[open, setOpen]=useState(true);
  const[wizard_anchor, setWizardAnchor]=useState();
  const[wizard_title, setWizardTitle]=useState();
  const[wizard_content, setWizardContent]=useState();
  const[step, setStep]=useState();
  const[anchorOrigin, setAnchorOrigin]=useState();
  const[transformOrigin, setTransformOrigin]=useState();
  let old_zindex=useRef();
  let old_z_index_b=useRef();

  let wizard_steps=props.wizard_steps;

    function next_wizard_step(step, back=false){
      let old_data=(step==0)?undefined:wizard_steps[step-1];
      old_data=(back==false)?old_data:wizard_steps[step+1];
      let data=wizard_steps[step];
      if(data==undefined){
        document.getElementById('wizard_background').style.zIndex='-10000000000';
        document.getElementById('wizard_background').style.opacity='0';
        if(old_data!=undefined){
          document.getElementById(old_data.key).style.zIndex=old_zindex.current;
          //if(old_data.key=='pv_wiz_1' && document.getElementById('pv_wiz_1_b')){document.getElementById('pv_wiz_1_b').style.zIndex=old_zindex_b.current;}
        }
        setOpen(false);
        props.wizardCompleted(props.type);
        props.onFinish();
      }else{
        document.getElementById('wizard_background').style.zIndex='999999999999';
        document.getElementById('wizard_background').style.opacity='0.6';
        if(old_data!=undefined){document.getElementById(old_data.key).style.zIndex=old_zindex.current;
          //if(old_data.key=='pv_wiz_1' && document.getElementById('pv_wiz_1_b')){document.getElementById('pv_wiz_1_b').style.zIndex=old_zindex_b.current;}
        }
        old_zindex.current=document.getElementById(data.key).style.zIndex;
        //if(data.key=='pv_wiz_1' && document.getElementById('pv_wiz_1_b')){old_z_index_b.current=document.getElementById('pv_wiz_1_b').style.index;}
        document.getElementById(data.key).style.zIndex='100000000000000';
        if(document.getElementById(data.key).style.position==undefined){document.getElementById(data.key).style.position='relative';}
        //if(data.key=='pv_wiz_1' && document.getElementById('pv_wiz_1_b')){document.getElementById('pv_wiz_1_b').style.zIndex='100000000000000';}
        setWizardTitle(data.title);
        setWizardContent(data.content)
        setAnchorOrigin(data.anchorOrigin);
        setTransformOrigin(data.transformOrigin);
        setWizardAnchor(document.getElementById(data.key));
      }
      setStep(step);
    }
    useEffect(()=>{
      if(props.me[props.type]!=true){next_wizard_step(0);}else{setOpen(false);}
    },[]);


    return(<Popover open={open} anchorEl={wizard_anchor} anchorOrigin={anchorOrigin} transformOrigin={transformOrigin}>{
              <div style={{padding:'10px', width:'400px'}}>
                <div>{wizard_title}</div>
                <hr style={{marginTop:'10px', marginBottom:'10px'}}/>
                <div>{wizard_content}</div>
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'10px'}}>
                      {(wizard_steps[step-1]==undefined)?null:<Button style={{marginRight:'20px'}} color='primary' variant='contained' onClick={()=>{next_wizard_step(step-1, true);}}>{'Back'}</Button>}
                      <Button color='secondary' variant='contained' onClick={()=>{next_wizard_step(step+1);}}>{(wizard_steps[step+1]==undefined)?'Finish':'Next'}</Button>
                </div>
              </div>
          }</Popover>)

}


export default connect(ss,dd)(Wizard);

function ss(state){
  return{
    me:state.account.me
  }
}

function dd(dispatch){
  return{
    wizardCompleted:(type)=>{dispatch({type:'REQUEST_WIZARD_COMPLETED', wizard_type:type})},
  }
}
